export default __webpack_public_path__ + "static/media/kitchen3-afterB-1920w.f685c185.webp";